import React from 'react';
import {useTranslation} from 'react-i18next';

import {Close, Info, Success, Warning} from '@ELib/assets/images';
import {classyArray} from '@ELib/utilities/HelperFunctions';

import {EIconButton} from './EButtons';
import {
  SnackbarCounter,
  StyledSnackbar,
  StyledStatusIcon,
} from './Snackbar.styles';

export enum SnackbarType {
  DELETE = 'delete',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
}

const statusIcons: Record<SnackbarType, React.ReactElement | undefined> = {
  [SnackbarType.DELETE]: undefined,
  [SnackbarType.INFO]: <Info />,
  [SnackbarType.SUCCESS]: <Success />,
  [SnackbarType.WARNING]: <Warning />,
};

export type SnackbarProps = {
  children?: React.ReactNode;
  className?: string;
  message: string;
  onClose?: () => void;
  snackbarType: SnackbarType;
  counter: number;
};

export const Snackbar = ({
  children,
  className,
  message,
  onClose,
  snackbarType,
  counter,
}: SnackbarProps): React.ReactElement => {
  const {t} = useTranslation('lib');

  return (
    <StyledSnackbar className={classyArray([snackbarType, className])}>
      {counter > 1 ? <SnackbarCounter>{counter}</SnackbarCounter> : null}
      {statusIcons[snackbarType] && (
        <StyledStatusIcon>{statusIcons[snackbarType]}</StyledStatusIcon>
      )}
      {message}
      {children}
      <EIconButton
        className='close-button'
        title={t('actions.close')}
        onClick={onClose}
      >
        <Close />
      </EIconButton>
    </StyledSnackbar>
  );
};
